import { forwardRef, type ReactNode } from 'react';

/** 48px header + 10.5 × 65px rows = 730.5px, rounded to a stable CSS pixel. */
export const CASH_LEDGER_TABLE_VIEWPORT_HEIGHT_PX = 731;
export const CASH_LEDGER_TABLE_HEADER_CLASS = 'bg-muted/95 sticky top-0 z-10 h-12 backdrop-blur-sm';
export const CASH_LEDGER_TABLE_ROW_CLASS = 'h-[65px]';

interface CashLedgerTableViewportProps {
  children: ReactNode;
  testId: string;
}

export const CashLedgerTableViewport = forwardRef<HTMLDivElement, CashLedgerTableViewportProps>(
  function CashLedgerTableViewport({ children, testId }, ref) {
    return (
      <div
        ref={ref}
        data-testid={testId}
        data-cash-ledger-table-viewport="true"
        className="border-border overflow-auto overscroll-contain border-t"
        style={{ height: CASH_LEDGER_TABLE_VIEWPORT_HEIGHT_PX }}
      >
        {children}
      </div>
    );
  },
);

export function CashLedgerPageScroll({ children }: { children: ReactNode }) {
  return (
    <div
      data-testid="cash-ledger-page-scroll"
      className="h-full space-y-4 overflow-y-auto overscroll-contain p-6"
    >
      {children}
    </div>
  );
}
